import { combineReducers } from 'redux';

import { parseStringToJSON } from 'redpoints-front-common/helpers';

import messages from './messages';

const socialMediaMessages = combineReducers({ messages });

export default socialMediaMessages;

export const getSocialMediaMessagesIsLoading = state =>
  state.socialMediaMessages.messages.isLoading;

export const getSocialMediaMessagesPreviousMessages = state => {
  const previousMessages =
    state.socialMediaMessages.messages.response?.data?.previousMessages;

  return previousMessages ? parseStringToJSON(previousMessages) : null;
};
export const getSocialMediaMessagesNextMessages = state => {
  const nextMessages =
    state.socialMediaMessages.messages.response?.data?.nextMessages;

  return nextMessages ? parseStringToJSON(nextMessages) : null;
};
